import React, { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { XCircleIcon } from "@heroicons/react/outline";
import { motion } from "framer-motion";

const getAnimationVariants = () => {
  return window.innerWidth < 640 // sm breakpoint
    ? {
        hidden: { opacity: 0, y: 50 }, // Slide up from bottom
        visible: { opacity: 1, y: 0, transition: { duration: 1 } },
        exit: { opacity: 0, y: 50, transition: { duration: 0.7 } },
      }
    : {
        hidden: { opacity: 0, rotateY: 90 }, // Flip effect
        visible: { opacity: 1, rotateY: 0, transition: { duration: 0.5 } },
        exit: { opacity: 0, rotateY: 90, transition: { duration: 0.5 } },
      };
};

const ModalComponent = ({ onClose, show, title, classes, children }) => {
  const flipVariants = getAnimationVariants(); // Get animation based on screen size

  return (
    <Transition appear show={show} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={onClose}>
        {/* Overlay */}
        <div className="fixed inset-0 bg-black bg-opacity-50" aria-hidden="true" />

        <div className="fixed inset-0 flex items-end sm:items-center justify-center p-4 text-center">
          <motion.div
            variants={flipVariants}
            initial="hidden"
            animate="visible"
            exit="exit"
            className={`${classes ? classes : "w-full"} max-w-lg lg:max-w-2xl xl:max-w-4xl 
                        mx-auto transform overflow-hidden 
                        bg-white p-6 shadow-xl 
                        rounded-t-2xl sm:rounded-2xl 
                        fixed bottom-0 left-0 sm:static sm:m-auto`}
          >
            <Dialog.Panel>
              <Dialog.Title className="text-lg flex justify-between font-medium leading-6 text-gray-900">
                <span className="text-primary text-xl">{title}</span>
                <XCircleIcon onClick={onClose} className="w-8 h-8 cursor-pointer bg-white" />
              </Dialog.Title>
              {children}
            </Dialog.Panel>
          </motion.div>
        </div>
      </Dialog>
    </Transition>
  );
};

export default ModalComponent;